import { render } from "./HiDialogButton.vue?vue&type=template&id=9f52fb9c"
import script from "./HiDialogButton.vue?vue&type=script&lang=js"
export * from "./HiDialogButton.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__